import React, { Component } from 'react';
import Projectmodal from './projectmodal.jsx';
import { toast } from 'react-toastify';
import moment from 'moment-jalaali';

//for connecting
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/project';

class Projectpage extends Component {

    constructor(props) {
        super(props);
        this.handleActiveChange = this.handleActiveChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.delete = this.delete.bind(this);
        this.state = {fetched: false}
    }

    init(props, state){
        if(props.app.work_space.id && !this.state.fetched ){
            this.setState({fetched: true, openModal: false})
            this.props.fetchProjectList();
        }
    }

    componentWillReceiveProps(nextProps, nextState){
        this.init(nextProps, nextState)
    }

    componentWillMount(){
        this.init(this.props, this.state)
    }
  
    handleActiveChange(id, status){
        this.props.changeActivationStatus(id, status)
    }


    toggleModal(project = {}){
        this.setState({openModal: !this.state.openModal, project})
    }

    delete = ( project={} )=>{
        if(!this.deleteNotifOpened){
          toast.info((
            <div className="delete-notif">
              <p>
              آیا برای حذف پروژه
              { ' "'+ project.name.trunc(18) +'" '}
              مطمئن هستید؟
              </p>
              <button className='btn btn-sm btn-success' onClick={this.props.deleteProject.bind(null, project.id)}>بله</button>
              <button className='btn btn-sm btn-danger'>خیر</button>
            </div>
            ), {
            onOpen: () => this.deleteNotifOpened = true,
            onClose: () => this.deleteNotifOpened = false,
            closeButton: false,
            rtl : true
          });
        }
        
    }

    render() {
        const appData = JSON.parse(localStorage.getItem('appData')) || {};
        let userPhone = (appData.user.phone_number).trim();
        let ownerPhone = '';
        let userPermissonsList = [];
        let projects = this.props.project.data;
        let duration;
        for(var i=0;i<projects.length;i++){
            ownerPhone = (this.props.project.data[i].owner.phone_number).trim();
            if(ownerPhone === userPhone) userPermissonsList.push(false);
            else userPermissonsList.push(true);
        }
        
        

        const mappedProjects = projects.map((project,index) =>{
            duration = moment.duration(project.total_time,'seconds');
            if( project.name !== 'بدون پروژه' ){
            return(
                <tr key={index}>
                    <td onClick={ ()=>{this.toggleModal(project)} }>{index+1}</td>
                    <td onClick={ ()=>{this.toggleModal(project)} }> {project.name.trunc(35)} </td>
                    <td onClick={ ()=>{this.toggleModal(project)} }> {project.owner.name.trunc(35)} </td>
                    <td >
                        <input disabled={userPermissonsList[index]} type='checkbox' checked={project.is_active} onChange={this.handleActiveChange.bind(null, project.id, project.is_active)} />
                    </td>
                    <td>
                        {parseInt(duration.asHours(),10) + ':'+ duration.minutes() + ':' + duration.seconds()}
                    </td>
                    <td onClick={ ()=>{this.toggleModal(project)} }> 
                        <div className="colorCircle" style={{backgroundColor:project.color}} > </div> 
                    </td>
                    <td style={{'cursor':'default'}}>
                        {(userPhone === project.owner.phone_number)?(
                                <i onClick={()=>{this.delete(project)}} style={{'cursor':'pointer'}} className="glyphicon glyphicon-trash"></i>
                        ):(null)}
                    </td>
                </tr>
            )}else{
                return true;
            }
            }
        );
        return (
            <div className="container">
                <div className="row title" >
                    <div className="col-md-3 col-md-push-1">
                        <h2>مدیریت پروژه ها</h2>
                    </div>
                    <div className="col-md-2 pull-left col-md-pull-1" >
                        <button className="btn btn-success btn-block btn-lg pull-left " style={{marginTop:'15px'}} onClick={ ()=>{this.toggleModal(null)} }>پروژه جدید</button>
                    </div>
                </div>            

                <div className="row">
                    <table className="table col-md-10 col-md-push-1 project-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>نام پروژه</th>
                                <th>مدیر پروژه</th>
                                <th>فعال بودن</th>
                                <th>مجموع زمان</th>
                                <th>رنگ</th>
                                <th>حذف</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mappedProjects}
                        </tbody>
                    </table>
                </div>
                { (this.state.openModal)?(<Projectmodal toggleModal={this.toggleModal} obj={this.state.project} />):(null) }
            </div>
        );
    }
    }

function mapStateToProps(state) {
  return {
    app: state.app,
    project: state.project
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}
  
export default connect(mapStateToProps, mapDispachToProps)(Projectpage);